/**
 * This is an example file for how to use Swiper
 * @see https://swiperjs.com/swiper-api
 *
 * Do not put your sliders in this file!
 * Create a different file for each section/block instead.
 */
import { Navigation, Pagination, Swiper } from 'swiper';
const testimonialsSections = document.querySelectorAll('section.testimonials');
Array.from(testimonialsSections).forEach(testimonialsSection => {
    const testimonialsSwiperEl = testimonialsSection.querySelector('.testimonials-swiper');
    new Swiper(testimonialsSwiperEl, {
        slidesPerView: 1,
        spaceBetween: 20,
        autoHeight: true,
        modules: [Navigation, Pagination],
        breakpoints: {
            768: {
                spaceBetween: 20,
            },
            992: {
                spaceBetween: 20,
            },
        },
        autoplay: {
            delay: 5000,
        },
        loop: true,
        // Prevent accidental trackpad sliding
        threshold: 4,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: testimonialsSection.querySelector('.swiper-button-next'),
            prevEl: testimonialsSection.querySelector('.swiper-button-prev'),
        },
    });
});
